module.exports = __webpack_public_path__ + "img/medal_3.2b75b4e1.png";